// extracted by mini-css-extract-plugin
export default {"footer":"CarouselFooter_footer__AgqCk","circle":"CarouselFooter_circle__qBj4p","filledCircle":"CarouselFooter_filledCircle__7fi0M"};